// © Microsoft Corporation. All rights reserved.

/// <reference path="lru-cache-for-clusters-as-promised.d.ts" />

/**
 * Used to mock the LRU cache in unit test environments.
 * Partial<LRUCache> is used to highlight this class is a subset of LRUCache and only
 * implements the functions we currently use out of this API. If more functions are
 * utilized they will need to be implmented here in this class.
 */
export class MockLRUCache implements Partial<LRUCache<string, any>> {
    /** cache */
    private cacheMap: Map<string, any> = new Map();

    /** Check if cache key exists */
    public async has(key: string): Promise<boolean> {
        return !!this.cacheMap[key];
    }
    /** Get cached value by key */
    public async get(key: string): Promise<string> {
        return this.cacheMap[key];
    }
    /** Set cached value by key */
    public async set(key: string, value: any, maxAge?: number): Promise<boolean> {
        this.cacheMap[key] = value;
        return true;
    }
    /** Delete cached key-value pair */
    public async del(key: string): Promise<void> {
        delete this.cacheMap[key];
    }
    /** Get count of total items cached */
    public async itemCount(): Promise<number> {
        return Object.keys(this.cacheMap).length;
    }
    /** Reset entire cache */
    public async reset(): Promise<void> {
        this.cacheMap = new Map();
    }
}